import { pawnArt } from '../lib/art';

/** Personagem do peão (arte do tema), no lugar do antigo emoji. */
export function PawnFace({ pawn, mood = 'idle' }: { pawn: number; mood?: 'idle' | 'happy' | 'sad' }) {
  return <img className="pawn-img" src={pawnArt(pawn)[mood]} alt="" draggable={false} />;
}
